import { render, staticRenderFns } from "./RateLimits.vue?vue&type=template&id=5f941a1e&"
import script from "./RateLimits.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RateLimits.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RateLimits.vue?vue&type=style&index=0&id=5f941a1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports